/** @format */

import {designListUngroupedTableColumns} from './design_list_ungrouped_table_columns';
import {designListUngroupedTableRows} from './design_list_ungrouped_table_rows';
import React, {useCallback, useContext, useEffect, useState} from 'react';
import {LoadMoreContextual} from 'frontier/components/search/load_more';
import {SearchContext} from 'frontier-search';
import {Table} from '@sttark/design-system';
import {If} from 'frontier-utilities';

// styles
import './design_list_ungrouped.scss';
import {CustomLoadMoreContextual} from '../custom_load_more_contextual';

export default function DesignListUngrouped() {
    const ctx = useContext(SearchContext);
    const [isShowingAll, setIsShowingAll] = useState(ctx.search != '' ? false : true);
    const [matchingDesignIds, setMatchingDesignIds] = useState([]);

    const [isShowingThumbnails, setIsShowingThumbnails] = useState(true);

    const handleToggleThumbnails = useCallback(() => {
        setIsShowingThumbnails(!isShowingThumbnails);
    }, [isShowingThumbnails]);

    const handleToggleShowAllDesigns = useCallback(() => {
        setIsShowingAll(!isShowingAll);
    }, [isShowingAll]);

    useEffect(() => {
        const {matchingDesignIds: newMatchingDesignids} = ctx.extraData;

        if (
            newMatchingDesignids &&
            newMatchingDesignids.length > 0 &&
            newMatchingDesignids != matchingDesignIds
        ) {
            setIsShowingAll(true);
        }
    }, [ctx.extraData]);

    const filterDesigns = ({design}) => {
        if (matchingDesignIds.length == 0 || isShowingAll) {
            return true;
        }

        return matchingDesignIds.findIndex(designId => designId == design.id) > -1;
    };

    const reducedDesigns = ctx.listItems.reduce((uniqueDesigns, item) => {
        item.designs_orders.forEach(dos => {
            if (!uniqueDesigns.some(uniqueDos => uniqueDos.design_id === dos.design_id)) {
                dos.order = {
                    ...item
                };
                uniqueDesigns.push(dos);
            }
        });
        return uniqueDesigns;
    }, []);

    let filteredDesigns = reducedDesigns.filter(filterDesigns);

    if (!isShowingAll && filteredDesigns.length > 5) {
        filteredDesigns = filteredDesigns.slice(0, 5);
    }

    const columns = designListUngroupedTableColumns({handleToggleThumbnails, isShowingThumbnails});
    const rows = designListUngroupedTableRows({isShowingThumbnails, filteredDesigns});

    // matchingIds need to be of type array
    useEffect(() => {
        const matchingIds = ctx.extraData.matchingDesignIds;
        if (Array.isArray(matchingIds)) {
            setMatchingDesignIds(matchingIds);
        } else if (typeof matchingIds === 'object' && !Array.isArray(matchingIds)) {
            setMatchingDesignIds(Object.values(matchingIds));
        } else {
            setMatchingDesignIds([]);
        }
    }, [ctx.extraData.matchingDesignIds]);

    return (
        <div className="reorder__design-list-88ty">
            <Table columns={columns} rows={rows} className="design_ungrouped-51yf" />

            <If condition={reducedDesigns.length != filteredDesigns.length}>
                <button
                    className="btn btn-secondary btn-sm mt-4"
                    onClick={handleToggleShowAllDesigns}>
                    Show All Designs
                </button>
            </If>
            <div style={{marginTop: 16}}>
                <LoadMoreContextual>
                    <CustomLoadMoreContextual />
                </LoadMoreContextual>
            </div>
        </div>
    );
}
